import { createSelector } from 'reselect';
import type { WhiteboardsEntrypointExperimentConfigState } from '../../../model/types.tsx';
import {
	type WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS,
	USER_PROPERTY_KEY_NAMES,
} from '../../../view/whiteboards-entrypoint-experiment/constants.tsx';
import type { State } from '../../types.tsx';

export const getWhiteboardsExperimentEntrypointConfig = (
	state: State,
): WhiteboardsEntrypointExperimentConfigState => state.config.whiteboardsEntrypointExperimentConfig;

export const getHasConfluenceAccess = (state: State): boolean =>
	getWhiteboardsExperimentEntrypointConfig(state).hasConfluenceAccess;

export const getHasConfluenceSpaces = (state: State): boolean =>
	getWhiteboardsExperimentEntrypointConfig(state).hasConfluenceSpaces;

export const getWhiteboardEligibility = (
	state: State,
): {
	flow: 'coUse' | 'crossFlow' | null;
	cohort: WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS | string;
} => getWhiteboardsExperimentEntrypointConfig(state).eligibility;

export const getHasXflowFromWhiteboardsTouchPoint = (state: State): boolean =>
	getWhiteboardsExperimentEntrypointConfig(state).hasXFlowFromWhiteboardsTouchpoint;

const getUserPropertyKeys = createSelector(
	[getWhiteboardsExperimentEntrypointConfig],
	(config: WhiteboardsEntrypointExperimentConfigState) => new Set(config?.userPropertyKeys ?? []),
);

export const hasDismissedBanner = createSelector([getUserPropertyKeys], (keys: Set<string>) =>
	keys.has(USER_PROPERTY_KEY_NAMES.BANNER_DISMISSED),
);

export const hasDismissedWhiteboardsEntrypoint = createSelector(
	[getUserPropertyKeys],
	(keys: Set<string>) => keys.has(USER_PROPERTY_KEY_NAMES.WHITEBOARDS_BACKLOG_ENTRYPOINT_DISMISSED),
);
